module.exports = __webpack_public_path__ + "img/rdv.8b2f2acc.svg";